<template>
  <div :class="$style.inputArea">
    <div :class="$style.textField">
      <label
        :class="$style.label"
        for="field">{{ computedLabel }}
      </label>
      <input
        :name="field"
        :id="field"
        ref="input"
        :class="$style.inputField"
        :placeholder="placeholder"
        :value="value"
        :autocomplete="autocomplete"
        type="text"
        @change="markAsChanged"
        @input="updateValue($event.target.value)">
    </div>
    <transition
      :name="$style.fade"
      appear>
      <span
        v-if="error"
        :class="$style.errorMessage"> {{ error }} </span>
    </transition>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
import validatedFieldMixin from 'src/mixins/validatedField';
/* Everything else */

export default {
  name: 'FormFieldInput',
  mixins: [validatedFieldMixin],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style lang="scss"
       module>
@import "src/brand/brandColors.variables";

.inputArea {
  margin: 0 1.6rem 1.6rem 0;
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  max-width: 37.1rem;
}

.textField {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  /*border: 1px solid $gray;*/
  height: 5rem;
}

.label {
  composes: standard from "src/brand/typography.scss";
  display: flex;
  justify-content: flex-start;
  padding: 0 2rem;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  background: $gray-light;
  color: $steel-gray;
  border: 1px solid $gray-light;
  text-transform: uppercase;
  width: 10rem;
  height: 100%;
}

.inputField {
  composes: standard from "src/brand/typography.scss";
  font-size: 1.4rem;
  color: $blue-dark;
  background-color: $white;
  height: 5rem;
  flex: 1;
  border: 1px solid $gray-light;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-left: 2.4rem;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: $gray-light;
  }
}

.errorMessage {
  composes: standard from "src/brand/typography.scss";
  color: $errors;
  display: block;
  margin-top: .6rem;
}
</style>
